import {FC} from 'react'
import {ColumnInstance} from 'react-table'
import {CustomHeader} from './CustomHeader'
import {Model} from '../../core/_models'

type Props = {
  column: ColumnInstance<Model>
}

const CustomHeaderColumn: FC<Props> = ({column}) => (
  <th {...column.getHeaderProps()} className='min-w-125px'>
    <CustomHeader tableProps={column} title={column.id} />
  </th>
)

export {CustomHeaderColumn}

